module.exports = __webpack_public_path__ + "img/ttsc.a9230dd6.png";